import { type ReactElement } from "react";
import { useParams } from "react-router-dom";
import { usePortal, findStage } from "../state/PortalContext.js";
import { FEATURE_SCREENS } from "../features/registry.js";

/** Renders a hosted feature's registered admin screen, driven by the catalog's permitted actions. */
export function FeaturePage(): ReactElement {
  const { api, catalog, me } = usePortal();
  const params = useParams();
  const serviceId = params.service!;
  const stageId = params.stage!;
  const featureId = params.feature!;

  const stage = findStage(catalog, serviceId, stageId);
  const feature = stage?.features.find((f) => f.id === featureId);

  if (!feature) return <p role="alert">Feature not available in this stage.</p>;
  const Screen = FEATURE_SCREENS[featureId];
  if (!Screen) return <p role="alert">No screen is registered for feature "{featureId}".</p>;

  const call = (surface: string, method: string, body?: Record<string, unknown>): Promise<unknown> =>
    api.feature(serviceId, stageId, featureId, surface, method, body);

  return <Screen serviceId={serviceId} stageId={stageId} featureId={featureId} actions={feature.actions} call={call} currentActorId={me.adminId} />;
}
